export default __webpack_public_path__ + "static/media/logoOld.f5e2aef9.png";